import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-593ee27f")

_pushScopeId("data-v-593ee27f")
const _hoisted_1 = { class: "question" }
const _hoisted_2 = { class: "title mb8" }
const _hoisted_3 = { class: "seq display-inline" }
const _hoisted_4 = { class: "type display-inline" }
const _hoisted_5 = { class: "q-name display-inline" }
const _hoisted_6 = { class: "score display-inline ml8" }
const _hoisted_7 = { class: "question-opt" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_tag = _resolveComponent("a-tag")
  const _component_result_card = _resolveComponent("result-card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.seq) + ".【", 1),
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.questionTypes[_ctx.questionType].name), 1),
      _createVNode("div", _hoisted_5, "】" + _toDisplayString(_ctx.stem), 1),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_a_tag, null, {
          default: _withId(() => [
            _createTextVNode("总分" + _toDisplayString(_ctx.score) + "分", 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.question[_ctx.questionType]), {
        pMetas: _ctx.pMetas,
        pAnswer: _ctx.vAnswer,
        stuAnswer: _ctx.vStuAnswer,
        onOnStuAnswer: _ctx.saveStuAnswer
      }, null, 8, ["pMetas", "pAnswer", "stuAnswer", "onOnStuAnswer"]))
    ]),
    (_ctx.jobView !== "submit")
      ? (_openBlock(), _createBlock(_component_result_card, {
          key: 0,
          cardModel: _ctx.cardModel,
          questionType: _ctx.questionType,
          stuTrue: _ctx.stuTrue,
          score: _ctx.score,
          stuScore: _ctx.stuScore,
          referenceAnswer: _ctx.answerText,
          analysis: _ctx.analysis,
          blankNumber: _ctx.blankNumber,
          questionId: _ctx.id,
          onOnSave: _ctx.reloadQuestion
        }, null, 8, ["cardModel", "questionType", "stuTrue", "score", "stuScore", "referenceAnswer", "analysis", "blankNumber", "questionId", "onOnSave"]))
      : _createCommentVNode("", true),
    _hoisted_8
  ]))
})